"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedMessage = void 0;
var _i18n = require("@ori/i18n");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

/**
 * Renders a formatted internationalized message using the provided translation data.
 *
 * @returns The FormattedMessage typed with keys within the specified namespace.
 */
const FormattedMessage = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
  ...props
});
exports.FormattedMessage = FormattedMessage;